module.exports = __webpack_public_path__ + "static/images/containers/EloLeaderboard/images/tab-border_active.bbd33980.png";


//////////////////
// WEBPACK FOOTER
// ./containers/EloLeaderboard/images/tab-border_active.png
// module id = 3104
// module chunks = 11